import apiClient from '@u/apiClient'
import actionsChiftInvoicing from './actions.chift_invoicing'
import actionsChiftAccounting from './actions.chift_accounting'
import GetAccountingDiaryListController from '@/wayfinder/actions/App/Http/Controllers/AccountingDiary/GetAccountingDiaryListController'
import GetAccountingDiaryByIdController from '@/wayfinder/actions/App/Http/Controllers/AccountingDiary/GetAccountingDiaryByIdController'
import CreateAccountingDiaryController from '@/wayfinder/actions/App/Http/Controllers/AccountingDiary/CreateAccountingDiaryController'
import UpdateAccountingDiaryController from '@/wayfinder/actions/App/Http/Controllers/AccountingDiary/UpdateAccountingDiaryController'
import DuplicateAccountingDiaryController from '@/wayfinder/actions/App/Http/Controllers/AccountingDiary/DuplicateAccountingDiaryController'
import DeleteAccountingDiaryController from '@/wayfinder/actions/App/Http/Controllers/AccountingDiary/DeleteAccountingDiaryController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

export default {
  ...actionsChiftInvoicing,
  ...actionsChiftAccounting,
  fetchAccountingDiaryList({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetAccountingDiaryListController.get())
        .then(async (response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // region Fetch
  fetchAccountingDiaryByID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetAccountingDiaryByIdController.get({ accounting_diary: payload.id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchNewAccountingDiary({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetNewModelController.get({ query: { model: 'accountingDiary' } })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // endregion

  // region store
  storeAccountingDiary({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateAccountingDiaryController.post(), payload.accounting_diary)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateAccountingDiary({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateAccountingDiaryController.put({ accounting_diary: payload.id }),
          payload.accounting_diary
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async duplicateAccountingDiary({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DuplicateAccountingDiaryController.put({
            accounting_diary: payload.id
          })
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          console.error('duplicateAccountingDiary', reason)
        })
    })
  },
  // endregion

  // region delete
  deleteAccountingDiaryById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteAccountingDiaryController.delete.delete({
            accounting_diary: payload.id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region undoDelete
  undoDeleteAccountingDiaryById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteAccountingDiaryController.undo.get({
            accounting_diary: payload.id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
  // endregion
}
